import { render, staticRenderFns } from "./FitnessplanChallenges.vue?vue&type=template&id=31b3fd62&scoped=true&"
import script from "./FitnessplanChallenges.vue?vue&type=script&lang=js&"
export * from "./FitnessplanChallenges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b3fd62",
  null
  
)

export default component.exports